import { render, staticRenderFns } from "./SystemSet.vue?vue&type=template&id=71ad404a&scoped=true&"
import script from "./SystemSet.vue?vue&type=script&lang=js&"
export * from "./SystemSet.vue?vue&type=script&lang=js&"
import style0 from "./SystemSet.vue?vue&type=style&index=0&id=71ad404a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad404a",
  null
  
)

export default component.exports